"use client"; 
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();
  const { type } = useParams();

  // Capitalize & format product name for the button label
  const getFormattedName = (slug) => {
    if (!slug) return "Blogs";
    const map = {
      "ai-lms": "LXP",
      "ai-lms-students": "LXP Students",
      "smart-forms": "Smart Forms",
      "ai-assistant": "AI Assistant",
    };
    return map[slug] || slug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const handleBackClick = () => {
    window.scrollTo(0, 0);
    // if (onClick) return onClick();
    // ✅ Always navigate to the correct product blog
    navigate(type ? `/blogs/${type}` : "/blog");
  };

  const buttonText = `Back to ${getFormattedName(type)} Blogs`;

  return (
    <ButtonContainer onClick={handleBackClick}>
      <IconWrapper>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3311_18)">
            <path
              d="M9 5L10.41 6.41L5.83 11H22V13H5.83L10.42 17.59L9 19L2 12L9 5Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_3311_18">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="matrix(-1 0 0 1 24 0)"
              />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
      <ButtonText>{buttonText}</ButtonText>
    </ButtonContainer>
  );
};

export default BackButton;

//
// ===== Styled Components =====
//
const ButtonContainer = styled.button`
  display: flex;
  height: 48px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background: linear-gradient(90deg, #5ea1ff 0%, #6a37e3 56.38%);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  @media (max-width: 640px) {
    padding: 8px 16px;
    height: 40px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonText = styled.span`
  color: #fff;
  text-align: center;
  letter-spacing: -0.075px;
  font: 700 15px/140% Inter, sans-serif;

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;
